import React from 'react';
import { useParams } from 'react-router';
import { createURL } from '@sm/utils';
import { PackageType } from '~pricing/lib/summaryPackages';

import ROUTE_CONFIG from './routes';
import NavItem from './NavItem';

import useNavigationStyles from './useStyles';

type NavRouteParams = {
  canonicalPath: string;
  subPath: string;
};

export default function Navigation(): React.ReactElement {
  const { canonicalPath = PackageType.Teams, subPath = '' } = useParams<NavRouteParams>();
  const { Container, List } = useNavigationStyles();

  return (
    <nav className={Container}>
      <ul className={List} role="tablist">
        {Object.keys(ROUTE_CONFIG).map(routeName => {
          const route = ROUTE_CONFIG[routeName as keyof typeof ROUTE_CONFIG];

          const navProps = {
            title: route.title,
            selected:
              canonicalPath === route.packageType ||
              (canonicalPath === 'educational' && route.packageType === 'individual')
                ? 'selected'
                : '',
            url: createURL(`${route.path}/${subPath}`, route.queryString),
          };

          return <NavItem {...navProps} key={routeName} />;
        })}
      </ul>
    </nav>
  );
}
